import * as React from "react";
import { NotifFromGrafferType } from "../../../../application/domain/notifi-from-graffer/notif-from-graffer";
import { SettingsTemplate } from "../../../template/settings/default-template";
import { SettingR } from "../route";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { GrafferNotifService } from "../../../../application/domain/notifi-from-graffer/notif-from-graffer-service";
import { useMount } from "../../../../utils/custom-hooks";

export const NotifFromGrafferDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [target, setTarget] = useState<NotifFromGrafferType | undefined>();

  useEffect(() => {
    (async () => {
      const data = await GrafferNotifService.fetchBySlug(slug);
      setTarget(data);
    })();
  }, [slug]);

  useMount(() => {
    GrafferNotifService.updateLastCheckedAt();
  });

  if (!target) {
    return null;
  }

  return (
    <SettingsTemplate
      breadcrumbs={[
        {
          to: SettingR.NotifFromGraffer.link({}),
          title: "Grafferからのお知らせ",
        },
        { to: SettingR.NotifFromGraffer.link({}), title: target.title },
      ]}
    >
      <h1 className="title">
        <i className="fa fa-envelope-o" /> {target.title}
      </h1>
      <div className="columns">
        <div className="column is-size-5 content">
          <div dangerouslySetInnerHTML={{ __html: target.content }} />
        </div>
      </div>
    </SettingsTemplate>
  );
};

export const NotifFromGrafferDetailContainer = NotifFromGrafferDetailPage;
